import React from "react";
import Graph from "../../../../etc/Graph";

const RAbstract = (parent) => {
	const record = parent.record;
	return (
		<div className="mt-6">
			<div className="d-flex justify-content-between align-items-center mb-px-26">
				<div className="d-flex align-items-center">
					<h3 className="con-title">초록</h3>
				</div>
			</div>
			<div>
				<div className="font-size-14 color-lightblack">{record.abstract}</div>
			</div>
		</div>
	);
};

export default RAbstract;
